import React, { useEffect, useState, useMemo } from "react";
import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import { alertTitleClasses, Box } from "@mui/material";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import Table from "./ReviewTable";
import MetaDataTable from "./MetaDataTable";
import DropdownsBar from "../../analytics/header/ProductSiteUnitSelector";
import HeadComp from "./HeadComp";
import Pagination from "../../../components/Pagination/index";
import MediaDialog from "../../../components/DialogBox/MediaDialog";
import Loader from "../../../components/Loader/loader";
import { useDispatch, useSelector } from "react-redux";
import * as review from "../../../redux/review/action";
import BreadcrumbHeader from "../../../components/Header/BreadCrumHeader";
import ListCard from "../../../components/Card/ListCard";
import debounce from "lodash.debounce";
import BatchFilterPopup from "./BatchFilterPopup";
import SnackBar from "../../../components/Snackbars/CustomizedSnackbars";
import Buttons from "../../../components/Controls/Buttons/Button";
import * as types from "../../../redux/review/types";
import ReviewAuditTable from "./ReviewAuditTable";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { getUsername } from "../../../constants/utility";
import ReportPopup from "../../../components/DialogBox/ErrorDialog";
import { formatLocal } from "../../../utility";
import { useLocation } from "react-router-dom";

const Index = () => {
  const location = useLocation();
  const {
    batchId: navBatchId,
    unitOfOperation: navUnitOfOperation,
    site: navSite,
    product: navProduct,
  } = location.state || {};

  const tableHeaders = [
    "Batch ID",
    "Date of Manufacture",
    "Status",
    // "Unit Operation",
    "Uploaded By",
    "Source",
    "Action",
  ];
  const metaTableHeaders = [
    "Batch ID",
    "Packaging 140mL.Fill Weight.Bottle ID",
    "Packaging 140mL.Fill Weight.Fill Weight (g)",
    "Action",
  ];

  const [isBatchType, setIsBatch] = useState("list");
  const [page, setPage] = useState(1);
  const [auditPage, setAuditPage] = useState(1);
  const [openData, setOpenData] = useState();
  const rowData = useSelector((state) => state?.reviewReducer?.reviewList);
  const media = useSelector((state) => state?.reviewReducer?.media);
  const updateData = useSelector((state) => state?.reviewReducer?.updateData);
  const menuData = useSelector((state) => state?.reviewReducer?.menuItem);
  const downloadTemp = useSelector(
    (state) => state?.reviewReducer?.downloadTemp,
  );
  const downloadExcelTemp = useSelector(
    (state) => state?.reviewReducer?.downloadTemp,
  );
  // const metaData = useSelector((state) => state?.reviewReducer?.metaData);
  const rowsPerPage = 50;
  const dispatch = useDispatch();
  const { product, site, unitOfOperation, selectedChart, selectedTab } =
    useSelector((state) => state.shared?.productSitesUopValues || {});
  const [search, setSearch] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState();
  const [selectedCheck, setSelectedCheck] = useState([]);
  const [selectedReviewCheck, setSelectedReviewCheck] = useState([]);
  const [selectedSheetCheck, setSelectedSheetCheck] = useState([]);
  const [batch, setBatch] = useState();
  const [metaData, setMetaData] = useState([]);
  const [open, setOpen] = useState(false);
  const [is_multi_approve, setIsMultiApprove] = useState();
  const [viewLogs, setViewLogs] = useState(false);
  const auditLogs = useSelector((state) => state?.reviewReducer?.audit_logs);
  const userList = useSelector((state) => state?.reviewReducer?.userList);
  const approveMulti = useSelector((state) => state?.reviewReducer?.approveMulti);
  const [filters, setFilters] = useState();
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [mediaSnack, setMediaSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [openReportModal, setOpenReportModal] = useState(false);
  const [reportType, setReportType] = useState("");
  const [reportData, setReportData] = useState(null);
  const [initialNavLoad, setInitialNavLoad] = useState(true);
  const userName = localStorage.getItem('userName');
  const [sortConfig, setSortConfig] = useState({
    sort_by: "created_at",
    sort_order: "desc",
  });
  // 1️⃣ Run when coming from another page with batchId
  useEffect(() => {
    if (navBatchId && initialNavLoad) {
      dispatch(
        review.getReviewDataList({
          page: 1,
          page_size: 1000,
          search: navBatchId,
          unit_op_id: navUnitOfOperation?.id,
        }),
      );

      setInitialNavLoad(false); // prevent running again
    }
  }, [navBatchId, initialNavLoad]);

  useEffect(() => {
    setFilters(
      viewLogs
        ? {
          updated_created_date: "",
          updated_end_date: "",
          batch_status: "",
        }
        : {
          from_date: "",
          to_date: "",
          batch_status: "",
          uploaded_by: "",
          approved_by: "",
          approve_start_date: "",
          approve_end_date: "",
          created_start_date: "",
          created_end_date: "",
        },
    );
  }, [viewLogs]);

  useEffect(() => {
    if (media?.status === 200) {
      setMediaSnack({
        open: true,
        message: media?.message,
        severity: "success",
      });
      if (media?.data?.batch_ids_ingested || media?.data?.ingested_file_id) {
        setReportType("success");
        setReportData({
          success_logs: {
            batch_ids_ingested: media?.data?.batch_ids_ingested,
            duplicate_batches_skipped: media?.data?.duplicate_batches_skipped,
            rows_inserted: media?.data?.rows_inserted,
            ingested_file_id: media?.data?.ingested_file_id,
            file_name: media?.data?.file_name,
          },
        });
        setOpenReportModal(true);
      }
      setIsBatch("list");
      setViewLogs(false);
      getListData(1);
    } else if (media?.message) {
      setMediaSnack({
        open: true,
        message: media?.message,
        severity: "error",
      });
      if (media?.errors && Array.isArray(media.errors)) {
        setReportType("error");
        setReportData({
          errors: media.errors,
          file_name: media.file_name,
          summary: media.summary,
        });
        setOpenReportModal(true);
        setOpen(false);
      } else if (media?.errors && typeof media.errors === "string") {
        setReportType("filelogs");
        setReportData({ file_logs: media.errors, file_name: media.file_name });
        setOpenReportModal(true);
        setOpen(false);
      }
    }
    dispatch({ type: types.CLEAR_REVIEW_MESSAGE });
  }, [media?.data]);

  useEffect(() => {
    if (updateData?.status === 200) {
      setSnack({
        open: true,
        message: updateData?.message,
        severity: "success",
      });
      let params = {
        batch_id: batch?.batch_id,
        unit_op_id: unitOfOperation?.id,
      };
      dispatch(review.getReviewMenu(params));
      //   const url = URL.createObjectURL(blob);
      //   const a = document.createElement("a");
      //   a.href = url;
      //   a.download = unitOfOperation.name+"_errors.txt";
      //   a.click();
      //   URL.revokeObjectURL(url);
    } else if (updateData?.message) {
      setSnack({
        open: true,
        message: updateData?.message,
        severity: "error",
      });
      setOpen(false);
    }
    // dispatch({ type: types.CLEAR_UPDATE_MESSAGE });
  }, [updateData]);

  useEffect(() => {
    if (downloadTemp?.status === 200) {
      setSnack({
        open: true,
        message: "Success",
        severity: "success",
      });
      const a = document.createElement("a");
      a.href = downloadTemp?.data;
      a.click();
      URL.revokeObjectURL(downloadTemp?.data);
    } else if (downloadTemp?.message) {
      setSnack({
        open: true,
        message: downloadTemp?.message,
        severity: "error",
      });
      setOpen(false);
    }
    dispatch({ type: types.CLEAR_DOWNLOAD_TEMPLATE });
  }, [downloadTemp?.data]);

  const handleChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  const handleReset = () => {
    setFilters(
      viewLogs
        ? { updated_created_date: "", updated_end_date: "", batch_status: "" }
        : {
          from_date: "",
          to_date: "",
          batch_status: "",
          uploaded_by: "",
          approve_start_date: "",
          approve_end_date: "",
          created_start_date: "",
          created_end_date: "",
        },
    );
    if (viewLogs) {
      getAuditData(1, true);
    } else {
      getListData(1, true);
    }
  };

  const handleGenerate = () => {
    if (viewLogs) {
      getAuditData(1);
    } else {
      setPage(1);
      getListData(1);
    }
  };

  const debouncedSetValue = useMemo(
    () =>
      debounce((val) => {
        setDebouncedSearch(val);
      }, 700),
    [],
  );

  const handleSearch = (e) => {
    setSearch(e.target.value);
    debouncedSetValue(e.target.value);
  };

  useEffect(() => {
    // if (initialNavLoad) return; // skip first load
    if (!unitOfOperation?.id) {
      return;
    }

    if (viewLogs) {
      getAuditData(1);
    } else {
      setIsMultiApprove(product?.is_multi_approve);
      getListData(1);
    }
    setSelectedCheck([]);
  }, [unitOfOperation, debouncedSearch]);



  const getListData = (page, reset = false, newSort = null) => {
    const params = {
      page: page,
      unit_op_id: unitOfOperation?.id,
      page_size: rowsPerPage,
      sort_by: newSort ? newSort.sort_by : sortConfig.sort_by,
      sort_order: newSort ? newSort.sort_order : sortConfig.sort_order,
    };
    // params.page_size = rowsPerPage;
    if (reset) return dispatch(review.getReviewDataList(params));
    if (filters?.from_date) params.start_date = formatLocal(filters.from_date);
    if (filters?.to_date) params.end_date = formatLocal(filters.to_date);
    if (filters?.approve_start_date)
      params.approve_start_date = formatLocal(filters.approve_start_date);
    if (filters?.approve_end_date)
      params.approve_end_date = formatLocal(filters.approve_end_date);
    if (filters?.batch_status) params.batch_status = filters.batch_status;
    if (filters?.approved_by) params.approved_by = filters.approved_by;
    if (filters?.uploaded_by) params.uploaded_by = filters.uploaded_by;
    if (filters?.created_start_date)
      params.created_start_date = formatLocal(filters.created_start_date);
    if (filters?.created_end_date)
      params.created_end_date = formatLocal(filters.created_end_date);
    if (debouncedSearch) params.search = debouncedSearch;

    dispatch(review.getReviewDataList(params));
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getListData(value);
  };

  const handleAuditPageChange = (event, value) => {
    setAuditPage(value);
    getAuditData(value);
  };

  const handleViewBatchMeta = (batch) => {
    setIsBatch("batch");
    let params = {
      batch_id: batch?.batch_id,
      unit_op_id: unitOfOperation?.id,
    };
    setSelectedCheck([]);
    setSelectedSheetCheck([]);
    setSelectedReviewCheck([]);
    // dispatch(review.getBatchMetaData(params));
    dispatch({ type: types.CLEAR_UPDATE_MESSAGE });
    dispatch(review.getReviewMenu(params));
  };

  const handleMenuClick = (batch) => {
    // if (openData?.id === batch?.id) {
    //   return setOpenData();
    // }
    setOpenData(batch);
    setMetaData(batch);
    // dispatch(review.getBatchMetaData(batch));
  };

  const handleUpload = (files) => {
    if (!unitOfOperation?.id) {
      return setSnack({
        open: true,
        message: "Please select a unit operation first.",
        severity: "warning",
      });
    }
    const formData = new FormData();
    formData.append("unit_operation_id", unitOfOperation?.id);
    formData.append("file", files[0]?.file);
    formData.append("uploaded_by", getUsername());

    dispatch(review.uploadMedia(formData));
  };

  const handleCheckBox = (value) => {
    // if (selectedCheck.includes(value)) {
    //   setSelectedCheck(selectedCheck.filter((item) => item !== value));
    // } else {
    //   setSelectedCheck([...selectedCheck, value]);
    // }
    setSelectedCheck(value)
  };

  const handleReviwCheckBox = (ids, sheet_id, bulk = false) => {
    const idsArray = Array.isArray(ids) ? ids : [ids];

    // Update selectedSheetCheck (keep previous logic)
    setSelectedSheetCheck((prev = []) => {
      if (prev.includes(sheet_id)) {
        return prev.filter((id) => id !== sheet_id);
      } else {
        if (bulk) return [...prev, sheet_id];
        return prev;
      }
    });

    // Update selectedReviewCheck
    setSelectedReviewCheck((prev = []) => {
      let updated = [...prev];

      if (bulk) {
        // Bulk add ids without duplicates
        idsArray.forEach((id) => {
          if (!updated.includes(id)) {
            updated.push(id);
          }
        });
        return updated;
      } else {
        // Toggle individual ids
        idsArray.forEach((id) => {
          if (updated.includes(id)) {
            updated = updated.filter((x) => x !== id);
          } else {
            updated.push(id);
          }
        });
        return updated;
      }
    });
  };

  const handlePrevClick = () => {
    let index = menuData?.data?.sheets?.findIndex(
      (item) => item.sheet_id === openData?.sheet_id,
    );
    let nextBatch = menuData?.data?.sheets[--index];
    handleMenuClick(nextBatch);
  };

  const handleNextClick = () => {
    let index = menuData?.data?.sheets?.findIndex(
      (item) => item.sheet_id === openData?.sheet_id,
    );
    let nextBatch = menuData?.data?.sheets[++index];
    handleMenuClick(nextBatch);
  };

  const handleClick = (row) => {
    handleViewBatchMeta(row);
    setBatch(row);
  };

  // const onDownloadClick = async () => {
  //   if (!unitOfOperation?.id) {
  //     return setSnack({
  //       open: true,
  //       message: "Please select a unit operation first.",
  //       severity: "warning",
  //     });
  //   }
  //   dispatch(
  //     review.downloadTemplate({
  //       product_id: product?.id,
  //       site_id: site?.id,
  //       unit_op_id: unitOfOperation?.id,
  //     }),
  //   );
  // };

  const onDownloadClick = async () => {
    if (!unitOfOperation?.id) {
      return setSnack({
        open: true,
        message: "Please select a unit operation first.",
        severity: "warning",
      });
    }
    try {
      const res = await dispatch(
        review.downloadExcelTemplate({
          unit_op_id: unitOfOperation?.id,
        })
      );

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      const contentDisposition = res.headers["content-disposition"];

      let fileName = "download.xlsx";

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) {
          fileName = match[1];

          if (!fileName.endsWith(".xlsx")) {
            fileName += ".xlsx";
          }
        }
      }
      a.href = url;
      a.download = fileName;;

      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      setSnack({
        open: true,
        message: res.data.message || "Downloaded successfully",
        severity: "success"
      });

    } catch (error) {
      setSnack({
        open: true,
        message: error.response?.data?.message || "Template Configuration Is In Progress.",
        severity: "error"
      });
    }
  };

  // const onDownloadClick = async () => {
  //   if (!unitOfOperation?.id) {
  //     return setSnack({
  //       open: true,
  //       message: "Please select a unit operation first.",
  //       severity: "warning",
  //     });
  //   }
  //   try {
  //     const res = await dispatch(
  //       review.downloadExcelTemplate({
  //         unit_op_id: unitOfOperation?.id,
  //       })
  //     );

  //     const blob = new Blob([res.data], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });

  //     const url = window.URL.createObjectURL(blob);

  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = `${unitOfOperation?.id}_template.xlsx`;

  //     document.body.appendChild(a);
  //     a.click();

  //     a.remove();
  //     window.URL.revokeObjectURL(url);

  //     setSnack({
  //       open: true,
  //       message: res.data.message || "Downloaded successfully",
  //       severity: "success"
  //     });

  //   } catch (error) {
  //     console.log(error, 'eror');
  //     setSnack({
  //       open: true,
  //       message: error.response?.data?.message || "Something went wrong",
  //       severity: "error"
  //     });
  //   }
  // };

  useEffect(() => {
    // if () {

    //   return handleMenuClick(exists);
    // }
    if (menuData?.data?.sheets) {
      const exists = menuData?.data?.sheets?.find(
        (batch) => batch?.sheet_id === metaData?.sheet_id,
      );
      const firstBatch = menuData?.data?.sheets[0];
      handleMenuClick(exists || firstBatch);
    }
  }, [menuData]);

  useEffect(() => {
    if (isBatchType === "list") {
      setMetaData(null);
      dispatch({ type: types.CLEAR_UPDATE_MESSAGE });
    }
  }, [isBatchType]);

  const viewAuditLogs = () => {
    setViewLogs((prev) => !prev);
    if (search) {
      setSearch(null);
    }
    if (!viewLogs) getAuditData();
  };

  const getAuditData = (page, reset = false) => {
    const params = {
      page: page,
      unit_op_id: unitOfOperation?.id,
      page_size: rowsPerPage,
    };
    if (reset) return dispatch(review.getReviewAudit(params));
    if (filters?.updated_created_date)
      params.start_date = formatLocal(filters.updated_created_date);
    if (filters?.updated_end_date)
      params.end_date = formatLocal(filters.updated_end_date);
    if (filters?.batch_status) params.status = filters.batch_status;
    if (debouncedSearch) params.search = debouncedSearch;
    dispatch(review.getReviewAudit(params));
  };

  const handleUpdateRow = (params) => {
    if (params.values.length === 0) {
      return setSnack({
        open: true,
        message: 'No values to update',
        severity: "error",
      });
    }

    dispatch(review.updateBatchData(params));
  };

  const handleApprove = () => {
    const totalRows = menuData?.data?.sheets?.reduce((acc, sheet) => {
      if (sheet.rows && sheet.rows.length > 0) {
        const validRows = sheet.rows.filter(
          (row) => row.status === "Draft" || row.status === "draft",
        );
        return acc + validRows.length;
      }
      return acc;
    }, 0);
    const selectedCount = selectedReviewCheck?.length || 0;
    if (selectedCount < totalRows) {
      const remaining = totalRows - selectedCount;
      setSnack({
        open: true,
        message: `Please select all rows before approving. ${remaining} row(s) remaining.`,
        severity: "error",
      });
      return;
    }

    dispatch(
      review.approveBatch({
        batch_id: batch?.batch_id,
        row_ids: selectedReviewCheck,
        unit_op_id: unitOfOperation?.id,
        approved_by: getUsername(),
      }),
    );
  };

  const handleMediaClose = () => {
    // if (media?.errors && Array.isArray(media.errors)) {
    //   const doc = new jsPDF();
    //   doc.text(media?.file_name?.split(".")[0] + ": Error logs", 14, 10);
    //   const columns = [
    //     { header: "S.No", dataKey: "sno" },
    //     { header: "Batch ID", dataKey: "batch_id" },
    //     { header: "Sheet", dataKey: "sheet" },
    //     { header: "Row", dataKey: "row" },
    //     { header: "Column", dataKey: "column" },
    //     { header: "Error Type", dataKey: "error_type" },
    //     { header: "Description", dataKey: "description" },
    //     { header: "Value", dataKey: "got_value" },
    //   ];

    //   // ✅ Map JSON to table rows
    //   const rows = media.errors.map((err, index) => ({
    //     sno: index + 1,
    //     batch_id: err.batch_id,
    //     sheet: err.sheet,
    //     row: err.row,
    //     column: err.column,
    //     error_type: err.error_type,
    //     description: err.description,
    //     got_value: err.got_value ?? "",
    //   }));

    //   autoTable(doc, {
    //     columns: columns,
    //     body: rows,
    //     startY: 15,
    //     theme: "grid",
    //     headStyles: { fillColor: [233, 233, 233], textColor: [0, 0, 0] },
    //     styles: { fontSize: 8, cellPadding: 2, overflow: "linebreak" },
    //     columnStyles: {
    //       description: { cellWidth: 50 },
    //       got_value: { cellWidth: 30 },
    //     },
    //   });

    //   // ✅ Save PDF
    //   doc.save(`${unitOfOperation.name}_error_logs.pdf`);
    // }

    setMediaSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleClose = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const filterOptions = [
    { label: "Approved", value: "Approved" },
    { label: "Draft", value: "Draft" },
  ];

  const handleFilterOpen = () => {
    setOpen(true);
    if (!userList) {
      dispatch(review.getUserList());
    }
  };

  const handleMultiApprove = async (row) => {
    try {
      const res = await dispatch(review.ApproveMultiBatch({ batch_ids: selectedCheck, approved_by: userName, unit_op_id: unitOfOperation?.id }));
      setSnack({
        open: true,
        message: res.data.message || "Approved successfully",
        severity: "success"
      });
      setTimeout(() => {
        setSnack({
          open: false,
          message: res.data.message || "Approved successfully",
          severity: "success"
        });
      }, 2000);
      setSelectedCheck([]);
      getListData(page);

    } catch (error) {
      setSnack({
        open: true,
        message: error.response?.data?.message || "Something went wrong",
        severity: "error"
      });
    }
  }

  const handleBackClick = () => {
    setIsBatch("list");
    getListData(1);
  }

  const handleAuditBackClick = () => {
    setViewLogs(false);
    getListData(1);
  }

  const handleSort = (column) => {
    setSortConfig((prev) => {
      let order = "asc";

      if (prev.sort_by === column) {
        order = prev.sort_order === "asc" ? "desc" : "asc";
      }

      const newSort = {
        sort_by: column,
        sort_order: order,
      };

      openData?.(newSort);
      // getListData(1, false, newSort);
      return newSort;
    });
  };

  return (
    <Box>
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        <DropdownsBar />
        {isBatchType === "list" && (
          <>
            <HeadComp
              text="Review"
              isButton={true}
              buttonText={"Upload Data"}
              onButtonClick={() => setIsBatch("upload")}
              handleSearch={handleSearch}
              search={search}
              handleClickFilter={handleFilterOpen}
              // anchorFilter={open}
              handleCloseFilter={() => setOpen(false)}
              selectedCheck={selectedCheck}
              onDownloadClick={onDownloadClick}
              viewAuditLogs={viewAuditLogs}
              viewLogs={viewLogs}
              onBackClick={handleAuditBackClick}
              placeholder="Search By Batch ID / Source"
              is_multi_approve={is_multi_approve}
              multipleApprove={handleMultiApprove}
              approveMulti={approveMulti}
              downloadExcelTemp={downloadExcelTemp}
            />

            <Box
              mt={1}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "calc(100vh - 165px)",
              }}
            >
              {!viewLogs ? (
                <>
                  <Table
                    tableHeaders={tableHeaders}
                    sortConfig={sortConfig}
                    handleSort={handleSort}
                    data={rowData || []}
                    // data={[]}
                    onView={handleClick}
                    selectedCheck={selectedCheck}
                    handleCheckBox={handleCheckBox}
                    handleMenuOption={handleClick}
                    moreOption={["View / Edit"]}
                    is_multi_approve={is_multi_approve}
                  />
                  {rowData?.loader && <Loader />}
                  <Pagination
                    count={rowData?.data?.total_records / rowsPerPage}
                    page={page}
                    onChange={handlePageChange}
                  />
                </>
              ) : (
                <>
                  <ReviewAuditTable data={auditLogs} />
                  {auditLogs?.loader && <Loader />}
                  <Pagination
                    count={auditLogs?.data?.total / rowsPerPage}
                    page={auditPage}
                    onChange={handleAuditPageChange}
                  />
                </>
              )}
            </Box>
          </>
        )}
        {isBatchType === "batch" && (
          <Box mt={1}>
            <BreadcrumbHeader
              first={"Batches"}
              third={"View Batch"}
              onBackClick={handleBackClick}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                mt: 2,
                borderTop: "1px solid #E9EAEB",
                paddingTop: 2,
              }}
            >
              <Box
                sx={{ height: "calc(100vh - 173px)", display: "flex", gap: 1 }}
              >
                <ListCard
                  data={menuData || []}
                  handleMenuClick={handleMenuClick}
                  openData={openData?.sheet_id}
                  batchData={batch}
                />
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="space-between"
                  height="calc(100vh - 180px)"
                  width="100%"
                >
                  <MetaDataTable
                    data={metaData || []}
                    openData={openData?.id}
                    selectedReviewCheck={selectedReviewCheck}
                    handleReviwCheckBox={handleReviwCheckBox}
                    moreOption={["Edit"]}
                    selectedSheetCheck={selectedSheetCheck}
                    onSaveRow={handleUpdateRow}
                    batchData={batch}
                    updateData={updateData}
                  />
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    justifyContent="space-between"
                    sx={{ padding: 1 }}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      {" "}
                      <Buttons
                        text={"Previous"}
                        onClick={handlePrevClick}
                        disabled={
                          menuData?.data?.sheets?.findIndex(
                            (item) => item?.sheet_id === openData?.sheet_id,
                          ) === 0
                        }
                      />
                      <Buttons
                        text={"Next"}
                        onClick={handleNextClick}
                        disabled={
                          menuData?.data?.sheets?.findIndex(
                            (item) => item?.sheet_id === openData?.sheet_id,
                          ) ===
                          menuData?.data?.sheets?.length - 1
                        }
                      />
                    </Box>
                    {/* <Buttons text={"Reject"} colors={"orange"} /> */}
                    {menuData?.data?.sheets?.findIndex(
                      (item) => item?.sheet_id === openData?.sheet_id,
                    ) ===
                      menuData?.data?.sheets?.length - 1 && (
                        <Buttons
                          colors={"success"}
                          text={"Approve"}
                          loading={media?.loader}
                          onClick={handleApprove}
                          disabled={menuData?.data?.batch_status === "Approved"}
                        />
                      )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        {isBatchType === "upload" && (
          <Box mt={1}>
            <BreadcrumbHeader
              text={"Upload Media"}
              onBackClick={() => setIsBatch("list")}
            />
            <Box sx={{ borderTop: "1px solid #E9EAEB", mt: 2 }}>
              <MediaDialog
                onClose={() => setIsBatch("list")}
                handleUpload={handleUpload}
                data={media}
                unitOfOperation={unitOfOperation?.id}
              />
            </Box>
          </Box>
        )}
        <BatchFilterPopup
          open={open}
          onClose={() => setOpen(false)}
          filterValues={filters}
          onChange={handleChange}
          onReset={handleReset}
          onGenerate={handleGenerate}
          isStatusVisible={!viewLogs}
          data={rowData || []}
          filterOptions={filterOptions}
          userList={userList?.data}
        />
        {snack?.open && (
          <SnackBar
            className="popup"
            handleClose={handleClose}
            severity={snack.severity}
            state={snack?.open}
            text={snack?.message}
            autoHide={false}
          />
        )}
        {mediaSnack?.open && (
          <SnackBar
            className="popup"
            handleClose={handleMediaClose}
            severity={mediaSnack.severity}
            state={mediaSnack?.open}
            text={mediaSnack?.message}
            autoHide={false}
          />
        )}
        <ReportPopup
          open={openReportModal}
          onClose={() => setOpenReportModal(false)}
          type={reportType}
          data={reportData}
        />
      </InvestigatorContainer>
    </Box>
  );
};

export default Index;